import { Component, OnInit } from '@angular/core';
import { fileOverviewService } from '../../portal/service/file-overview.service'
import { NgxSpinnerService } from "ngx-spinner";
// import { WorkOrderService } from '../../operation/service/work-order.service';
// import { BillService } from '../../operation/service/bill.service';
// import { MasterDataService } from "../../operation/service/master-data.service";
// import { MainService as MainServiceInventory } from '../../inventory/service/main.service';
// import { MainService as MainServiceAccounts } from '../../accounts/service/main.service';
// import { MainService as MainServiceHr } from '../../hrms/service/main.service';
// import { MainService as MainServiceOp } from '../../operation/service/main.service';
// import { MainService as MainServiceMD } from '../../md/service/main.service';
// import {MainService as ComputerMainService} from '../../computer/service/main.service'
// import {MainService as StoreMainService} from '../../stm/service/main.service'
import { DatePipe } from '@angular/common';
import Swal from "sweetalert2";
import { Router } from '@angular/router';
import { session } from 'src/environments/environment.session';
declare var $: any;


@Component({
  selector: 'app-file-over-view',
  templateUrl: './file-over-view.component.html',
  styleUrls: ['./file-over-view.component.css'],
  providers: [DatePipe]
})
export class FileOverViewComponent {
  // todayDate: string;
  // previousMonthStartDate: string;
  // previousMonthEndDate: string;
  // constructor(private datePipe: DatePipe, private _router: Router, public fileOverviewService: fileOverviewService,
  //    private spinner: NgxSpinnerService, private workOrderService: WorkOrderService, private billService: BillService, 
  //    private masterDataService: MasterDataService, private MainServiceInventory: MainServiceInventory, 
  //    private MainServiceAccounts: MainServiceAccounts, private MainServiceHr: MainServiceHr, 
  //    private MainServiceOp: MainServiceOp, private MainServiceMD: MainServiceMD,
  //   private storeMainService :StoreMainService,
  //   private computerMainService : ComputerMainService
  //   ) {
  //   const today = new Date();
  //   this.todayDate = this.formatDate(today);


  //   const previousMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
  //   this.previousMonthStartDate = this.formatDate(previousMonth);

  //   const previousMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);
  //   this.previousMonthEndDate = this.formatDate(previousMonthEnd);


  // }

  // formatDateReverse(date: string | Date): string {
  //   return this.datePipe.transform(date, 'dd-MM-yyyy')!;
  // }

  // formatDate(date: Date): string {
  //   const day = date.getDate().toString().padStart(2, '0');
  //   const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
  //   const year = date.getFullYear();

  //   return `${year}-${month}-${day}`; // Format: YYYY-MM-DD
  // }
  // mainRole: any;
  // erpUser: any;
  // b_acct_id: any;
  // async ngOnInit() {
  //   this.mainRole = "Director"
  //   let requiredRole: any = ["DIRECTOR"]
  //   this.erpUser = this.utf8EncodingService.decodeFromUtf8((session.erpUser));
  //   // requiredRole.map((x: any) => {
  //   //   if (!this.erpUser['role_cd'].includes(x)) {
  //   //     this._router.navigate(['./index']); //route to portal
  //   //   }
  //   // })

  //   if (!this.erpUser['role_cd'].includes('DIRECTOR') && !this.erpUser['role_cd'].includes('Dir')) {
  //     this._router.navigate(['./index']); //route to portal
  //   }

  //   this.b_acct_id = this.erpUser.b_acct_id;
  //   this.spinner.show()
  //   await this.getvender()
  //   await this.getPdiComp()
  //   await this.getAllComponent()
  //   await this.workInfoDtl()
  //   await this.getAllTaskOfUser()
  //   await this.getscheme()
  //   await this.getactivity()
  //   // await this.getPdi()
  //   //Operation data
  //   await this.getWorkOrder()
  //   await this.getBill()
  //   //Account data
  //   await this.getAccountDataToMap()
  //   //Computer data
  //   await this.getComputerDataToMap()
  //   //Store data
  //   await this.getStoreDataToMap()
  //   //Inventory Data
  //   await this.getinventoryDataToMap()
  //   //Hr Data
  //   await this.getAccountUserInfo()

  //   this.spinner.hide()

  // }


  // userObj: any = {};
  // users: any;
  // async getAccountUserInfo() {
  //   var obj: any = new Object();
  //   obj["b_acct_id"] = this.b_acct_id;
  //   obj["module_cd"] = "OPERATION";
  //   var resp = await this.MainServiceMD.getuserformodulerolemapping(
  //     JSON.stringify(obj)
  //   );
  //   if (resp["error"] == false) {
  //     this.users = resp.data;
  //   }
  // }

  // async goToFIle(element: any) {
  //   // operation/operation-index

  //   $('#myModal1').modal('hide');
  //   if (element.module_cd == "OPERATION") {
  //     this.billService.fromFile_OverView = { 'element': element, flag: true }
  //     this.MainServiceOp.fromFile_OverView = { 'element': element, flag: true }
  //     let route: any = element.doc_type == "VENDOR_BILL" ? '/operation/bill' : element.doc_type == "PDI" ? '/operation/pdi' : '/operation/workOrder'
  //     this._router.navigate([route]);
  //   } else if (element.module_cd == "HR") {
  //     await this.getHrBill(element.doc_local_no)
  //     this.MainServiceHr.fromFile_OverView = { 'element': this.requiredHrBill[0], flag: true }
  //     let route: any = element.doc_type == "SAL_BILL" ? "/hrms/payroll/sal-bill" : "/hrms/hrms-index"
  //     this._router.navigate([route]);
  //   } else if (element.module_cd == "ACCOUNT") {
  //     this.MainServiceAccounts.fromFile_OverView = { 'element': element, flag: true }
  //     let route: any = element.doc_type == "MANUAL_JOURNAL" ? `/accounts/ledger/jrnl` : element.doc_type == "BP" ? "/accounts/bank-payment" : "/accounts/dep-bill"
  //     this._router.navigate([route]);
  //   } else if (element.module_cd == "STM") {
  //     this.storeMainService.fromFile_OverView = { 'element': element, flag: true }
  //     let route: any = element.doc_type == "STM_FILE" ? `/stm/file` :"/"
  //     this._router.navigate([route]);
  //   } else if (element.module_cd == "COMPUTER") {
  //     this.computerMainService.fromFile_OverView = { 'element': element, flag: true }
  //     let route: any = element.doc_type == "COMPUTER_FILE" ? `/computer/file` : '/'
  //     this._router.navigate([route]);
  //   }
  //    else if (element.module_cd == "INVENTORY") {
  //     this.MainServiceInventory.fromFile_OverView = { 'element': element, flag: true }
  //     let route: any = element.doc_type == "Note Sheet" ? `/inventory/note-sheet` : `/inventory/rate-discovery`
  //     this._router.navigate([route]);
  //   }
  // }

  // allTaskArr: any = [];
  // approvedByUser: any = []
  // pendingOnThisUser: any = [];
  // rejectedByUser: any = []
  // pendingOnAll: any = []
  // async getAllTaskOfUser() {
  //   this.allTaskArr = []
  //   var obj = Object()
  //   obj['b_acct_id'] = this.erpUser.b_acct_id
  //   obj["status"] = 'PENDING'
  //   obj["provided_date"] = "" // will be use letter..if there's is requiremnet for data from specific date ..
  //   var resp = await this.fileOverviewService.tasksOfUser(JSON.stringify(obj))
  //   if (resp['error'] == false) {

  //     this.pendingOnAll = resp['data'];

  //     this.pendingOnAll.map((x: any) => {
  //       // x['reuiredPendingUser'] = x.user_id ;
  //       if (x.user_id == this.erpUser.user_id) {
  //         this.pendingOnThisUser.push(x)
  //       }
  //     })
  //     // this.pendingOnThisUser = resp['data']
  //     await this.getPdi()

  //     this.allPdiList.map((item: any) => {
  //       if (item.is_dir_send == "YES") {

  //         // director has already assigned this pdi to somebody
  //         if (item.isComp == false) { //this pdi has not component

  //           if (item.life_cycle_status != "APPROVED") {

  //             this.pendingOnAll.push(item)
  //             item['status'] = item.life_cycle_status
  //             item['user_id_pdi'] = item.assign_id != null ? item.assign_id : item.verifier_id

  //           } else {
  //             item['status'] = "APPROVED"
  //             // item['user_id_pdi'] = item.assign_id != null ? item.assign_id : item.verifier_id
  //             item['user_id_pdi'] = item.verifier_id != null ? item.verifier_id : (item.assign_id !== null ? item.assign_id : 'N/A')
  //             this.approvedByUser.push(item)
  //           }

  //         } else {

  //           let comp = item.componentsOfPdi

  //           // first we have to assign the name of the component to each component ...
  //           comp.map((k: any) => {
  //             this.components.map((y: any) => {
  //               if (y.item_compo_id == k.item_comp_id) {
  //                 k['component_name'] = y.component_name
  //               }
  //             })

  //             k['module_cd'] = "OPERATION"
  //             k.create_timestamp = k.txn_start;
  //             k['doc_type'] = "PDI"
  //             k['doc_local_no'] = item.doc_local_no
  //             k['work_order_id'] = item.work_order_id
  //             k['notesheet_id'] = item.notesheet_id
  //             k['vendor_id'] = item.vendor_id
  //             k['status'] = k.life_cycle_status
  //             k['pdi_id'] = item.pdi_id
  //             k['assign_id'] = item.assign_id

  //             if (k.life_cycle_status != "APPROVED") {
  //               k['user_id_pdi'] = k.assign_id
  //             } else {
  //               k['user_id_pdi'] = k.verifier_id !== null ? k.verifier_id : k.assign_id
  //             }
  //             // k['user_id_pdi'] = item.assign_id != null ? item.assign_id : item.verifier_id

  //           })


  //           const notApprovedComps = comp.filter((obj: { life_cycle_status: string; }) => obj.life_cycle_status !== 'APPROVED'); // will get the comps which are not approved ..
  //           const approvedComps = comp.filter((obj: { life_cycle_status: string; }) => obj.life_cycle_status === 'APPROVED'); // will get the comps which are approved ...



  //           if (!notApprovedComps || notApprovedComps.length == 0) {
  //             item['status'] = "APPROVED"
  //             // this.approvedByUser.push(...item.componentsOfPdi)
  //             this.approvedByUser.push(...approvedComps)
  //           } else {
  //             item['status'] = "PENDING"
  //             // this.pendingOnAll.push(...item.componentsOfPdi)
  //             this.pendingOnAll.push(...notApprovedComps)
  //             this.approvedByUser.push(...approvedComps)

  //           }

  //         }
  //       }
  //     })




  //   } else {
  //     Swal.fire("Error", "Error While Getting Pending Data", 'error');
  //   }

  //   obj['user_id'] = this.erpUser.user_id

  //   obj["status"] = 'APPROVED'
  //   var resp2 = await this.fileOverviewService.tasksOfUser(JSON.stringify(obj))
  //   if (resp2['error'] == false) {


  //     let temp: any = resp2['data']
  //     // Use a Set to track unique ids
  //     let seenIds: any = []
  //     resp2['data'] = temp.filter((e: any) => {
  //       if (!seenIds.includes(e.doc_local_no)) {
  //         seenIds.push(e.doc_local_no);
  //         return true;
  //       }
  //       return false;
  //     });


  //     this.approvedByUser.push(...resp2['data'])
  //     this.approvedByUser.map((x: any) => {

  //     })
  //     // await this.getPdi()
  //   } else {
  //     Swal.fire("Error", "Error While Getting Approved Data", 'error');
  //   }

  //   obj["status"] = 'REJECTED'
  //   var resp3 = await this.fileOverviewService.tasksOfUser(JSON.stringify(obj))
  //   if (resp3['error'] == false) {

  //     let temp: any = resp3['data']
  //     // Use a Set to track unique ids
  //     let seenIds: any = []
  //     resp3['data'] = temp.filter((e: any) => {
  //       if (!seenIds.includes(e.doc_local_no)) {
  //         seenIds.push(e.doc_local_no);
  //         return true;
  //       }
  //       return false;
  //     });



  //     this.rejectedByUser = resp3['data']
  //   } else {
  //     Swal.fire("Error", "Error While Getting Rejected Data", 'error');
  //   }
  // }


  // allpending: any = false;
  // async showPending(t: any) {
  //   if (t == "ALL") {
  //     this.allpending = true;
  //     await this.moduleChange('OPERATION')
  //     this.pageSize = 10; // number of items per page
  //     this.currentPage = 0;
  //   }
  //   if (t == "CURRENT") {
  //     this.allpending = false;
  //     await this.moduleChange('OPERATION')
  //     this.pageSize = 10; // number of items per page
  //     this.currentPage = 0;
  //   }
  // }
  // selectedModule: any = "OPERATION"
  // list_type: any;
  // allList: any = []
  // async selectedList(listType: any) {
  //   this.list_type = listType      // ALL , PENDING , REJECTED , APPR

  //   this.allpending = false;
  //   this.allList = []
  //   if (listType == 'PENDING') {
  //     $('#pd2').removeClass('active');
  //     $('#pd1').addClass('active');
  //     this.allpending = false;
  //     await this.moduleChange('OPERATION')
  //   } else if (listType == "APPR") {
  //   } else if (listType == "REJECTED") {
  //   } else {
  //     this.pendingOnThisUser.map((item: any) => this.allList.push(item))
  //     this.approvedByUser.map((item: any) => this.allList.push(item))
  //     this.rejectedByUser.map((item: any) => this.allList.push(item))

  //   }

  //   $('#hrTab').removeClass('active');
  //   $('#invenTab').removeClass('active');
  //   $('#comTab').removeClass('active');
  //   $('#stmTab').removeClass('active');
  //   $('#acTab').removeClass('active');
  //   $('#opTab').addClass('active');


  //   await this.moduleChange('OPERATION')
  //   this.pageSize = 10; // number of items per page
  //   this.currentPage = 0;
  //   $('#myModal1').modal('show');
  // }

  // allListModuleeWise: any = []
  // async moduleChange(module: any) {
  //   this.selectedModule = module  // operation , account , hr or inventory ...
  //   this.allListModuleeWise = []
  //   let dataToShow: any = []
  //   // this.allListModuleeWise = this.allpending == true ? (this.list_type == "ALL") ? await this.allList.filter(item => item.module_cd === this.selectedModule) : (this.list_type == 'PENDING') ? await this.pendingOnAll.filter(item => item.module_cd === this.selectedModule) : (this.list_type == "APPR") ? await this.approvedByUser.filter(item => item.module_cd === this.selectedModule) : await this.rejectedByUser.filter(item => item.module_cd === this.selectedModule) : (this.list_type == "ALL") ? await this.allList.filter(item => item.module_cd === this.selectedModule) : (this.list_type == 'PENDING') ? await this.pendingOnThisUser.filter(item => item.module_cd === this.selectedModule) : (this.list_type == "APPR") ? await this.approvedByUser.filter(item => item.module_cd === this.selectedModule) : await this.rejectedByUser.filter(item => item.module_cd === this.selectedModule);

  //   if (this.allpending) {
  //     this.allListModuleeWise = (this.list_type == "ALL") ? await this.allList.filter((item: { module_cd: any; }) => item.module_cd === this.selectedModule) : (this.list_type == 'PENDING') ? await this.pendingOnAll.filter((item: { module_cd: any; }) => item.module_cd === this.selectedModule) : (this.list_type == "APPR") ? await this.approvedByUser.filter((item: { module_cd: any; }) => item.module_cd === this.selectedModule) : await this.rejectedByUser.filter((item: { module_cd: any; }) => item.module_cd === this.selectedModule);  // Data will be bifergated as per List Type i.e Pending/Approved/rejected ...
  //   } else {
  //     this.allListModuleeWise = (this.list_type == "ALL") ? await this.allList.filter((item: { module_cd: any; }) => item.module_cd === this.selectedModule) : (this.list_type == 'PENDING') ? await this.pendingOnThisUser.filter((item: { module_cd: any; }) => item.module_cd === this.selectedModule) : (this.list_type == "APPR") ? await this.approvedByUser.filter((item: { module_cd: any; }) => item.module_cd === this.selectedModule) : await this.rejectedByUser.filter((item: { module_cd: any; }) => item.module_cd === this.selectedModule);  // Data will be bifergated as per List Type i.e Pending/Approved/rejected ...
  //   }

  //   let forWordedBys: any = []
  //   let docLocalNums: any = []
  //   this.spinner.show()
  //   /* mapping workflow log to the Respectiove Modules  */
  //   await this.allListModuleeWise.map((x: any) => {


  //     // this.pendingOnAll.map((t: any) => {
  //     //   if (x.pdi_id == t.pdi_id ) {
  //     //     x['user_name'] = t.user_name
  //     //   }
  //     // })

  //     x.component_name = x.component_name != null ? x.component_name : "N/A"
  //     if (x.user_id_pdi) {
  //       this.users?.map((item: any) => {
  //         if (x.user_id_pdi == item.user_id) {
  //           x['user_name'] = item.emp_name
  //         }
  //       })
  //     }
  //     /* Operation > Work Order .. */
  //     if (x.doc_type == 'WORK ORDER' && x.module_cd == "OPERATION") {
  //       this.all_workOrder.map((y: any) => {
  //         if (y.work_order_id == x.doc_local_no) {
  //           x['work_order_no'] = y['work_order_no'];
  //           x['work_order_id'] = y['work_order_id'];
  //           x['vendor_id'] = y['vendor_id']
  //           x['notesheet_id'] = y['notesheet_id']

  //         }
  //       })
  //     }
  //     /* Operation > BIll .. */
  //     if (x.doc_type == "VENDOR_BILL" && x.module_cd == "OPERATION") {
  //       this.all_bill.map((y: any) => {
  //         if (y.bill_id == x.doc_local_no) {
  //           x['work_order_no'] = y['bill_sh_id  '];
  //           x['vendor_id'] = y['vendor_id']
  //           x['work_order_id'] = y['work_order_id'];
  //           x['notesheet_id'] = y['notesheet_id'];
  //           x['status'] = y.life_cycle_status
  //         }
  //       })
  //     }
  //     // HR _._!_._
  //     if (x.module_cd == "HR") {
  //       forWordedBys.push(x.forwarded_by)
  //       docLocalNums.push(x.doc_local_no)
  //       this.allProj_heir.map((item: any) => {
  //         if (x.node_cd == item.leaf_cd) {
  //           x['leaf_value'] = item['leaf_value']
  //         }
  //       })
  //     }
  //     /* Accounts .. */
  //     if (x.module_cd == "ACCOUNT") {
  //       /* there are 4 types of doc_types in Accounts
  //       1. bp
  //       2. VENDOR_BILL_OPERATION
  //       3. SALARY_BILL
  //       4. MANUAL_JOURNAL
  //       */
  //       x['description_account'] = 'N/A'
  //       if (x.doc_type == "BP") {
  //         x['description_account'] = x['doc_desc']
  //       } else if (x.doc_type == "MANUAL_JOURNAL") {
  //         this.unpostedJrnlList.map((y: any) => {

  //           if (y['id'] == x['doc_local_no']) {
  //             x['description_account'] = y['preparer_comment']
  //           }
  //         })
  //       } else if (x.doc_type == "VENDOR_BILL_OPERATION") {
  //         this.eventGroup.map((y: any) => {
  //           if (y['id'] == x['doc_local_no']) {
  //             x['file_status'] = y['status']
  //             let openingBracket = y['local_doc_desc'].indexOf('for'); //for spliting
  //             x['description_account'] = y['local_doc_desc'].substring(openingBracket + 3);
  //             // x['description_account'] = x['doc_desc']
  //             x['vendor_id'] = y.vendor_id
  //           }
  //         })
  //       } else if (x.doc_type == "SALARY_BILL") {
  //         this.eventGroup.map((y: any) => {
  //           // x['description_account'] = y['id'] == x['doc_local_no'] ? y['local_doc_desc'] : "N/A"
  //           if (y['id'] == x['doc_local_no']) {
  //             x['description_account'] = y.local_doc_desc
  //             x['file_status'] = y['status']
  //             x['description_account'] = y.local_doc_desc
  //             // let openingBracket = y['local_doc_desc'].indexOf('for'); //for spliting
  //             // x['description_account'] = y['local_doc_desc'].substring(openingBracket + 3);
  //           }
  //         })
  //       } else if (x.doc_type == "DA_ARREAR_BILL") {
  //         this.eventGroup.map((y: any) => {
  //           //  y['id'] == x['doc_local_no'] ? y['local_doc_desc'] : "N/A"
  //           if (y['id'] == x['doc_local_no']) {
  //             x['file_status'] = y['status']
  //             x['description_account'] = y['local_doc_desc']
  //           }
  //         })
  //       }


  //       // set user name
  //     }

  //     /* Computer ..*/
  //     if (x.module_cd == "COMPUTER") {
  //       if (x.doc_type == "COMPUTER_FILE") {
  //         this.computer_file.map((y: any) => {
  //           if (y['work_id'] == x['doc_local_no']) {
  //             x['file_status'] = y['status']
  //             x['work_order_no'] = y['work_order_no']
  //             x['vendor_name'] = this.vendoe_obj_on_le_id?.[y.party_le_id]?.org_name
  //           }
  //         })
  //       }
  //     }

  //     /* Store ..*/
  //     if (x.module_cd == "STM") {
  //       if (x.doc_type == "STM_FILE") {
  //         this.store_file.map((y: any) => {
  //           if (y['work_id'] == x['doc_local_no']) {
  //             x['file_status'] = y['status']
  //             x['work_order_no'] = y['work_order_no']
  //             x['vendor_name'] = this.vendoe_obj_on_le_id?.[y.party_le_id]?.org_name
  //           }
  //         })
  //       }
  //     }


  //     /* INVENTORY */
  //     if (x.module_cd == "INVENTORY") {
  //       x['product'] = "undifined"
  //       if (x.doc_type == "Note Sheet") {
  //         this.notesheetData.map((y: any) => {
  //           if (x['doc_local_no'] == y['id']) {
  //             x['product'] = y['scheme_name']
  //           }
  //         })
  //       } else if (x.doc_type == "Rate_Discovery") {
  //         this.RateDiscovery.map((y: any) => {
  //           if (x['doc_local_no'] == y['id']) {
  //             x['product'] = y['scheme_name']
  //           }
  //         })
  //       }
  //     }

  //   })
  //   this.spinner.hide()
  //   this.pageSize = 10; // number of items per page
  //   this.currentPage = 0;
  //   this.showingAll = false

  //   if (module !== "HR") {
  //     return
  //     /*
  //       if its HR then we need to show user name ..as per requirement design
  //       for that we have to get user name from the workflow log with the help
  //       of user id
  //     */
  //   }

  //   let obj: any = {};
  //   obj['b_acct_id'] = this.b_acct_id;
  //   obj['docs'] = forWordedBys  //  all user IDs and doc local nums .. we need to know the user name of these users
  //   obj['local_nums'] = docLocalNums;
  //   obj['module_cd'] = 'HR'
  //   let userNames: any = []
  //   this.spinner.show()
  //   let resp = await this.fileOverviewService.getUserNameById(JSON.stringify(obj))
  //   this.spinner.hide()
  //   if (resp['error'] == false) {
  //     userNames = resp['data']
  //   }
  //   this.allListModuleeWise.map((x: any) => {
  //     userNames.map((item: any) => {
  //       if (x.doc_local_no === item.doc_local_no) {
  //         x['userName'] = item.user_name
  //       }
  //     })
  //   })

  // }

  // all_workOrder: any = []
  // work_order_items: any = []
  // async getWorkOrder() {
  //   let obj: any = {};
  //   obj['b_acct_id'] = this.b_acct_id;
  //   let resp = await this.workOrderService.getWorkOrder(JSON.stringify(obj))
  //   if (resp['error'] == false) {
  //     this.all_workOrder = resp['data']
  //     this.work_order_items = resp['work_order_items']
  //   } else {
  //     // Swal.fire('Error', 'Error while getting work order', 'error')
  //   }

  // }


  // v_bill_info: any = []
  // all_bill: any = [];
  // c_bill_info: any;
  // dist_cd: any = []
  // async getBill() {
  //   let obj: any = {}
  //   obj['b_acct_id'] = this.b_acct_id
  //   // obj['life_cycle_status']='GENERATED'
  //   let resp = await this.billService.getBill(JSON.stringify(obj))
  //   if (resp['error'] == false) {
  //     this.all_bill = resp['bill_info']
  //   } else {
  //     // Swal.fire('Error', resp['data'], 'error')
  //   }
  // }


  // work_info: any = []
  // work_obj: any = {}
  // work_items: any = []
  // async workInfoDtl() {
  //   let obj: any = {}
  //   obj['b_acct_id'] = this.b_acct_id;
  //   let resp = await this.masterDataService.getWorkInfo(JSON.stringify(obj));
  //   if (resp['error'] == false) {
  //     this.work_info = resp['data']
  //     this.work_info.map((x: { [x: string]: string | number; }) => {
  //       this.work_obj[x['work_order_id']] = x
  //     })
  //     this.work_items = resp['work_items']
  //   } else {
  //     // Swal.fire('Error', 'Error while getting  work data', 'error')
  //   }


  // }

  // scheme_data: any = []
  // scheme_obj: any = []
  // async getscheme() {
  //   let obj: any = {}
  //   obj['b_acct_id'] = this.b_acct_id;
  //   obj['status'] = 'APPROVED'
  //   let resp = await this.masterDataService.getscheme(JSON.stringify(obj));
  //   if (resp['error'] == false) {
  //     this.scheme_data = resp['data']
  //     this.scheme_data.map((x: any) => {
  //       this.scheme_obj[x['notesheet_id']] = x
  //     })
  //   } else {
  //     // Swal.fire('Error', 'Error while gettting  sceme data', 'error')
  //   }
  // }




  // allProj_heir: any
  // async getactivity() {
  //   let obj: any = new Object();
  //   obj["b_acct_id"] = this.b_acct_id;
  //   let resp = await this.fileOverviewService.getprojHier(JSON.stringify(obj));
  //   if (resp['error'] == false) {
  //     this.allProj_heir = resp['data']
  //   } else {
  //     // Swal.fire('Error', 'Error while gettting =proj hier', 'error')
  //   }
  // }

  // requiredHrBill: any
  // async getHrBill(doc_local_no: any) {
  //   let obj: any = {}
  //   obj['b_acct_id'] = this.b_acct_id;
  //   obj['doc_local_no'] = doc_local_no
  //   this.spinner.show()
  //   let resp = await this.fileOverviewService.getRequierdHrBll(JSON.stringify(obj))
  //   this.spinner.hide()
  //   if (resp['error'] == false) {
  //     this.requiredHrBill = resp['data']
  //   } else {
  //     // Swal.fire('Error', 'Error while gettting Hr Bill ', 'error')
  //   }
  // }


  // vendor_data: any = []
  // vendor_obj: any = []
  // vendoe_obj_on_le_id: any = {}
  // async getvender() {
  //   let obj: any = {}
  //   obj['b_acct_id'] = this.b_acct_id;
  //   let resp = await this.workOrderService.getvendor(JSON.stringify(obj))
  //   if (resp['error'] == false) {
  //     resp['data'].map((x: { [x: string]: string | number; }) => {
  //       this.vendor_obj[x['vendor_id']] = x
  //       this.vendoe_obj_on_le_id[x['le_id']] = x
  //     })
  //     this.vendor_data = resp['data']
  //   } else {
  //     // Swal.fire('Error', 'Error while gettting vender data', 'error')
  //   }
  // }


  // unpostedJrnlList: any = []
  // eventGroup: any = []
  // async getAccountDataToMap() {
  //   let obj: any = {}
  //   obj['b_acct_id'] = this.b_acct_id;

  //   let resp0: any = await this.fileOverviewService.getUnpostedJrnl(JSON.stringify(obj))
  //   if (resp0['error'] == false) {
  //     this.unpostedJrnlList = resp0['data']
  //   } else {
  //     // Swal.fire('Error', 'Error while gettting Unposted Jnrl', 'error')
  //   }

  //   let resp1: any = await this.fileOverviewService.getEventGroup(JSON.stringify(obj))
  //   if (resp1['error'] == false) {
  //     this.eventGroup = resp1['data']
  //   } else {
  //     // Swal.fire('Error', 'Error while gettting Event Group', 'error')
  //   }
  // }


  // computer_file: any = []
  // async getComputerDataToMap() {
  //   let obj: any = {}
  //   obj['b_acct_id'] = this.b_acct_id;
  //   let resp0: any = await this.fileOverviewService.getComputerFileList(JSON.stringify(obj))
  //   if (resp0['error'] == false) {
  //     this.computer_file = resp0['data']
  //   } else {
  //     // Swal.fire('Error', 'Error while gettting Unposted Jnrl', 'error')
  //   }
  // }


  // store_file: any = []
  // async getStoreDataToMap() {
  //   let obj: any = {}
  //   obj['b_acct_id'] = this.b_acct_id;
  //   let resp0: any = await this.fileOverviewService.getStoreFileList(JSON.stringify(obj))
  //   if (resp0['error'] == false) {
  //     this.store_file = resp0['data']
  //   } else {
  //     // Swal.fire('Error', 'Error while gettting Unposted Jnrl', 'error')
  //   }
  // }

  // notesheetData: any = []
  // RateDiscovery: any = []
  // async getinventoryDataToMap() {
  //   let obj: any = {}
  //   obj['b_acct_id'] = this.b_acct_id;
  //   let resp0: any = await this.fileOverviewService.getNotesheet(JSON.stringify(obj))
  //   if (resp0['error'] == false) {
  //     this.notesheetData = resp0['data']
  //   } else {
  //     // Swal.fire('Error', 'Error while gettting Notesheet data', 'error')
  //   }

  //   let resp1: any = await this.fileOverviewService.getallratediscovery(JSON.stringify(obj))
  //   if (resp1['error'] == false) {
  //     this.RateDiscovery = resp1['data']
  //   } else {
  //     // Swal.fire('Error', 'Error while gettting RateDiscovery data', 'error')

  //   }
  // }


  // allPdiList: any = []
  // allPdiComp: any = []
  // async getPdiComp() {
  //   var obj = Object()
  //   obj['b_acct_id'] = this.erpUser.b_acct_id
  //   let resp_pdi_c = await this.fileOverviewService.getpdiComp(JSON.stringify(obj))
  //   if (resp_pdi_c['error'] == false) {
  //     this.allPdiComp = resp_pdi_c['data']
  //   } else {
  //     // Swal.fire('Error', 'Error while gettting Pdi Component ', 'error')
  //   }
  // }

  // async getPdi() {
  //   var obj = Object()
  //   obj['b_acct_id'] = this.erpUser.b_acct_id
  //   let resp: any = await this.fileOverviewService.getPdi(JSON.stringify(obj))
  //   if (resp['error'] == false) {
  //     this.allPdiList = resp['data']
  //     // map data as per list ...
  //     this.allPdiList.map((x: any) => {
  //       x['isComp'] = false
  //       let allCompOfThisPdi: any = []
  //       //check if pdi comp ;
  //       this.allPdiComp.map((y: any) => {
  //         if (y.pdi_request_id == x.pdi_request_id) {
  //           //this pdi has component ..
  //           allCompOfThisPdi.push(y)
  //           x['isComp'] = true;
  //         }
  //       })

  //       x['componentsOfPdi'] = allCompOfThisPdi
  //       x['module_cd'] = "OPERATION";
  //       x['create_timestamp'] = x.pdi_date
  //       x['doc_type'] = "PDI";
  //       x['doc_local_no'] = x.pdi_id

  //       this.work_info.map((item: any) => {
  //         if (x.work_order_id === item.work_order_id) {
  //           x['notesheet_id'] = item.notesheet_id
  //         }
  //       })
  //     })


  //   } else {
  //     // Swal.fire('Error', 'Error while gettting Pdi ', 'error')
  //   }
  // }


  // // paginator
  // pageSize = 10; // number of items per page
  // currentPage = 0;
  // filterValue: any

  // get paginatedData() {
  //   // const startIndex = this.currentPage * this.pageSize;
  //   // return this.allListModuleeWise.slice(startIndex, startIndex + this.pageSize);
  //   const startIndex = this.currentPage * this.pageSize;

  //   let filteredData = this.allListModuleeWise;

  //   if (this.filterValue) {
  //     filteredData = filteredData.filter((ob: { [x: string]: any; }) => {
  //       return Object.keys(ob).some(key => {
  //         return String(ob[key]).toLowerCase().includes(this.filterValue.toLowerCase());
  //       });
  //     });
  //   }
  //   return filteredData.slice(startIndex, startIndex + this.pageSize);
  // }

  // nextPage() {
  //   this.currentPage++;
  //   this.showingAll = false
  // }

  // previousPage() {
  //   // this.currentPage--;
  //   this.currentPage = this.showingAll == true ? 10 : this.currentPage - 1;
  //   this.showingAll = false
  // }
  // LastPage() {
  //   this.currentPage = this.allListModuleeWise.length % this.pageSize == 0 ? Math.floor(this.allListModuleeWise.length / this.pageSize) - 1 : Math.floor(this.allListModuleeWise.length / this.pageSize)
  //   this.showingAll = false
  // }

  // showingAll: boolean = false
  // allPage() {
  //   this.currentPage = 0;
  //   this.pageSize = this.allListModuleeWise.length
  //   this.showingAll = true
  // }

  // lessPage() {
  //   this.pageSize = 10; // number of items per page
  //   this.showingAll = false
  // }



  // components: any = []
  // async getAllComponent() {
  //   let obj: any = {}
  //   obj['b_acct_id'] = this.b_acct_id

  //   let resp = await this.fileOverviewService.getAllComp(JSON.stringify(obj))
  //   if (resp['error'] == false) {
  //     this.components = resp['data']
  //   } else {
  //     Swal.fire('Error', 'Server side error', 'error')
  //   }

  // }
}
